import { observer } from 'mobx-react-lite';
import { Platform } from 'react-native';
import { useStore } from 'src/contexts/StoreContext';
import { AuthView } from '../auth-view/AuthView';
import { AuthType } from '../auth-view/LazyAuthView.types';

export const GoogleOneTapLogin = observer(() => {
  const {
    user: { isLogged },
  } = useStore();

  return !isLogged && Platform.OS === 'web' ? (
    <AuthView type={AuthType.AUTH_WITH_GOOGLE_ONE_TAP} afterCompletedAuthentication={() => {}} />
  ) : (
    <></>
  );
});
